import { TypingConfiguration } from 'Interfaces/apiDtos';
import { ConfigStoreState } from './index.types';

/**
 * Returns the typing-indicator timings from the signed-in person config.
 * Returns `null` when the config has not been loaded yet or does not
 * expose a valid typing configuration.
 */
export const selectTypingConfig = (
  state: ConfigStoreState
): TypingConfiguration | null => {
  const typing = state.signedInPersonConfig?.typing;

  if (
    !typing ||
    typeof typing.refreshIntervalMs !== 'number' ||
    typing.refreshIntervalMs <= 0 ||
    typeof typing.idleStopMs !== 'number' ||
    typing.idleStopMs <= 0 ||
    typeof typing.peerExpiryMs !== 'number' ||
    typing.peerExpiryMs <= 0
  ) {
    return null;
  }

  return typing;
};
